"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationsApi = void 0;
var Superagent = require("superagent");
var buildQuery_1 = require("./buildQuery");
var TranslationsApi = function () {
  function TranslationsApi(config) {
    this.url = config.url;
    this.queryTransformer = config.queryTransformer;
    this.defaultHeaders = config.defaultHeaders;
    this.eTagHeaderName = config.eTagHeaderName;
    this.useETag = config.useETag;
  }
  TranslationsApi.prototype.fetch = function (data) {
    var _a;
    var locale = data.locale,
      spaces = data.spaces,
      eTag = data.eTag;
    return Superagent.get(this.url).set(this.useETag && eTag ? __assign(__assign({}, this.defaultHeaders), (_a = {}, _a[this.eTagHeaderName] = eTag, _a)) : __assign({}, this.defaultHeaders)).query(buildQuery_1.buildQuery(locale, spaces, this.queryTransformer));
  };
  return TranslationsApi;
}();
exports.TranslationsApi = TranslationsApi;